module.exports = __webpack_public_path__ + "static/img/y62.4c585b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y62.jpg
// module id = D1FQ
// module chunks = 1